import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-117455e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h5-jump-config" }
const _hoisted_2 = { class: "config-container" }
const _hoisted_3 = { class: "jump-section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label" }, "统一跳转")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "custom-section"
}
const _hoisted_6 = { class: "section-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label custom-label" }, "自定义", -1))
const _hoisted_8 = { class: "ctr-range-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "range-label" }, "CTR范围值:", -1))
const _hoisted_10 = { class: "range-inputs" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-separator" }, "-", -1))
const _hoisted_12 = { class: "save-section" }

import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { PlusOutlined, MinusOutlined, SaveOutlined } from "@ant-design/icons-vue";
import { Empty } from "ant-design-vue";
import {
  jumpConfig,
  jumpConfigSave,
  jumpConfigCtr,
  jumpConfigCtrSave,
} from "@/api/api";
import { message } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'H5JumpConfig',
  setup(__props) {

const router = useRouter();

const configList = ref([
  { type: 0, appName: "火山开发者" },
  { type: 1, appName: "玫瑰开发者" },
]);
const activeKey = ref(0);

// 跳转选项配置
const jumpOptions = reactive([
  { label: "默认", value: "0" },
  { label: "外部", value: "1" },
  { label: "内部", value: "2" },
  { label: "自定义", value: "3" },
]);

// 响应式数据
const selectedJumpType = ref("0");
const selectedCtrType = ref("default");
const loading = ref(false);
const saving = ref(false);
const jumpConfigId = ref(0);

// CTR配置数组
const ctrConfigs = ref([
  {
    jump: 0,
    ctrRange: {
      min: 0,
      max: 100,
    },
  },
]);

// 添加CTR配置
const addCtrConfig = () => {
  ctrConfigs.value.push({
    jump: 0,
    ctrRange: {
      min: 0,
      max: 100,
    },
  });
};

// 保存CTR配置
const saveCtrConfigs = () => {
  let list = handleCtrConfigs();
  return saveCtrConfigRequest(list);
};

// 保存CTR配置请求
const saveCtrConfigRequest = (list: any[]) => {
  return jumpConfigCtrSave({
    type: activeKey.value,
    list: list,
  });
};

const handleCtrConfigs = () => {
  let list: any[] = [];
  ctrConfigs.value.forEach((item: any) => {
    var params: any = {
      ctrRange: `${item.ctrRange.min},${item.ctrRange.max}`,
      jump: item.jump,
      type: activeKey.value,
    };
    if (item.id >= 0) {
      params.id = item.id;
    }
    list.push(params);
  });
  return list;
};

// 删除CTR配置
const removeCtrConfig = (index: number) => {
  if (ctrConfigs.value.length > 1) {
    ctrConfigs.value.splice(index, 1);
  }
};

// 获取CTR范围值数据格式
const getCtrRangeData = () => {
  return ctrConfigs.value.map((config) => {
    const rangeStr =
      config.ctrRange.min !== null && config.ctrRange.max !== null
        ? `${config.ctrRange.min},${config.ctrRange.max}`
        : "";
    return {
      ctrRange: rangeStr,
      jump: config.jump,
    };
  });
};

// 处理跳转类型变化
const handleJumpTypeChange = (e: any) => {
  //console.log("选择的跳转类型:", selectedJumpType.value);
  if (selectedJumpType.value === "3") {
    //console.log("启用自定义配置");
  }
};

// 保存所有配置
const handleSave = async () => {
  saving.value = true;
  
  try {
    // 保存跳转配置
    let jumpParams: any = {
      type: activeKey.value,
      jump: Number(selectedJumpType.value),
    };
    if (jumpConfigId.value > 0) {
      jumpParams.id = jumpConfigId.value;
    }
    
    await jumpConfigSave(jumpParams);
    
    // 如果是自定义配置，还需要保存CTR配置
    if (selectedJumpType.value === "3") {
      await saveCtrConfigs();
    }
    
    message.success("配置保存成功");
  } catch (error) {
    console.error("保存失败:", error);
    message.error("保存失败，请重试");
  } finally {
    saving.value = false;
  }
};

const tabClick = (key: string) => {
  activeKey.value = Number(key);
  ctrConfigs.value = [
    {
      jump: 0,
      ctrRange: {
        min: 0,
        max: 100,
      },
    },
  ];
  jumpConfigId.value = 0;
  selectedJumpType.value = "0";
  getJumpConfig();
};

// 处理CTR类型变化
const handleCtrTypeChange = () => {
  //console.log("选择的CTR类型:", selectedCtrType.value);
};

// 返回上一页
const goBack = () => {
  router.go(-1);
};

const getCtrConfig = () => {
  loading.value = true;
  jumpConfigCtr({
    type: activeKey.value,
  }).then((res) => {
    //console.log(res);
    if (res.data && res.data.length) {
      ctrConfigs.value = res.data;
      ctrConfigs.value.forEach((item: any) => {
        item.ctrRange = item.ctrRange.split(",");
        item.ctrRange.min = Number(item.ctrRange[0]);
        item.ctrRange.max = Number(item.ctrRange[1]);
      });
    } else {
      // 如果没有数据，清空配置数组，显示空状态
      ctrConfigs.value = [];
    }
  }).catch((error) => {
    console.error("获取CTR配置失败:", error);
    message.error("获取配置失败，请重试");
    ctrConfigs.value = [];
  }).finally(() => {
    loading.value = false;
  });
};

const getJumpConfig = () => {
  loading.value = true;
  jumpConfig({
    type: activeKey.value,
  }).then((res) => {
    //console.log(res);
    if (res.data) {
      selectedJumpType.value = res.data.jump.toString();
      jumpConfigId.value = res.data.id || 0;
      if (selectedJumpType.value === "3") {
        getCtrConfig();
      }
    } else {
      // 如果没有数据，使用默认值
      selectedJumpType.value = "0";
      jumpConfigId.value = 0;
    }
  }).catch((error) => {
    console.error("获取跳转配置失败:", error);
    message.error("获取配置失败，请重试");
    selectedJumpType.value = "0";
    jumpConfigId.value = 0;
  }).finally(() => {
    loading.value = false;
  });
};

onMounted(() => {
  getJumpConfig();
});

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_tabs, {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
      onTabClick: tabClick
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.type,
            tab: item.appName,
            disabled: loading.value
          }, null, 8, ["tab", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_spin, {
          spinning: loading.value,
          tip: "加载中..."
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_a_radio_group, {
                value: selectedJumpType.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedJumpType).value = $event)),
                onChange: handleJumpTypeChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jumpOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_a_radio, {
                      key: option.value,
                      value: option.value,
                      class: "radio-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"]),
              _createVNode(_component_a_alert, {
                message: "选择默认表示不统一配置，遵循App内的配置，自定义则根据规则来跳转",
                type: "info",
                "show-icon": ""
              })
            ]),
            (selectedJumpType.value === '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_a_button, {
                      type: "primary",
                      shape: "circle",
                      size: "small",
                      class: "add-btn",
                      onClick: addCtrConfig
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(PlusOutlined))
                      ]),
                      _: 1
                    })
                  ]),
                  (ctrConfigs.value.length === 0)
                    ? (_openBlock(), _createBlock(_component_a_empty, {
                        key: 0,
                        description: "暂无配置数据",
                        image: _unref(Empty).PRESENTED_IMAGE_SIMPLE
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: addCtrConfig
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 添加配置 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["image"]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(ctrConfigs.value, (config, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ctr-config",
                          key: index
                        }, [
                          _createVNode(_component_a_select, {
                            value: config.jump,
                            "onUpdate:value": ($event: any) => ((config.jump) = $event),
                            class: "ctr-dropdown",
                            placeholder: "请选择类型"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("默认")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("外部")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("内部")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["value", "onUpdate:value"]),
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_a_input_number, {
                                value: config.ctrRange.min,
                                "onUpdate:value": ($event: any) => ((config.ctrRange.min) = $event),
                                class: "range-input",
                                placeholder: "最小值",
                                min: 0
                              }, null, 8, ["value", "onUpdate:value"]),
                              _hoisted_11,
                              _createVNode(_component_a_input_number, {
                                value: config.ctrRange.max,
                                "onUpdate:value": ($event: any) => ((config.ctrRange.max) = $event),
                                class: "range-input",
                                placeholder: "最大值",
                                min: 0
                              }, null, 8, ["value", "onUpdate:value"])
                            ])
                          ]),
                          (ctrConfigs.value.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "primary",
                                danger: "",
                                shape: "circle",
                                size: "small",
                                class: "remove-btn",
                                onClick: ($event: any) => (removeCtrConfig(index))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(MinusOutlined))
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["spinning"]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "large",
            loading: saving.value,
            onClick: handleSave
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(SaveOutlined))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 保存配置 ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ], 64))
}
}

})